module.exports = __webpack_public_path__ + "img/wagner.0d565dbd.jpg";